import { sliderMediaBreakPoints } from '@helpers/utils.js';
import TabNavFields from '../fields/tabNavFields';

const {
  i18n: { __ },
  components: { PanelBody },
} = wp;

const TabContentSettings = ({
  tabNavSliderSettings,
  setSliderSettingAttribute,
  tabNavs,
  removeSliderSettingAttribute,
}) => {
  return (
    <PanelBody title={__('Navigation Settings', 'b3rg')} initialOpen={false}>
      {sliderMediaBreakPoints
        .map((sliderMediaBreakPoint) => {
          const breakPoint = sliderMediaBreakPoint.breakPoint;
          const deviceSlug = sliderMediaBreakPoint.slug;
          return (
            <TabNavFields
              key={breakPoint}
              {...{
                sliderMediaBreakPoint,
                sliderSettings: tabNavSliderSettings[deviceSlug],
                slides: tabNavs,
                setSliderSettingAttribute,
                removeSliderSettingAttribute,
              }}
            />
          );
        })
        .reverse()}
    </PanelBody>
  );
};

export default TabContentSettings;
